export enum CalendarType {
    Events = 1,
    Tasks = 2
}
